import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ children, isAuthenticated, requiredRole, requiredRoles, userRole }) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Support multiple roles via requiredRoles array
  if (requiredRoles && requiredRoles.length > 0) {
    if (!requiredRoles.includes(userRole)) {
      return <AccessDenied />;
    }
  }

  // Support single role via requiredRole string (backward compatible)
  if (requiredRole && !requiredRoles && userRole !== requiredRole) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
